import { Image } from '@myua/icons/dist/bulk16';
import { Button } from '@myua/kit';
import { useRef } from 'react';
import { ALLOWED_MIME_TYPES } from '../model';

export const FilePicker = ({
  isActive,
  isUploading,
  onChange,
}: {
  isActive: boolean;
  isUploading: boolean;
  onChange: (file: File) => void;
}) => {
  const ref = useRef<HTMLInputElement | null>(null);

  return (
    <>
      <Button
        className={`al-search-file-picker ${!isActive ? 'al-btn-blue-icon' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          ref.current?.click();
        }}
        title="Upload a file to search by image"
        icon={<Image />}
        loading={isUploading}
        type={isActive ? 'primary' : undefined}
      />
      <input
        ref={ref}
        type="file"
        accept={ALLOWED_MIME_TYPES.join(',')}
        style={{ display: 'none' }}
        value=""
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file) {
            onChange(file);
          }
        }}
      />
    </>
  );
};
